const isDisplayedGranteeSitPro = ({ getMiddleBoolean }) =>
  getMiddleBoolean('BENEFICIAIRE_SIT_PRO_EST_NECESSAIRE') &&
  getMiddleBoolean('BENEFICIAIRE_SIT_PRO_EST_DEMANDE_DONNEES_CONTRAT');

export { isDisplayedGranteeSitPro };
